import createReducer from '../utils/createReducer';
import {
  IDENTITY_PRESETS_REQUEST,
  IDENTITY_PRESETS_FAILURE,
  IDENTITY_PRESETS_SUCCESS,

} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null,
};

export default createReducer(initialState, {
  [IDENTITY_PRESETS_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [IDENTITY_PRESETS_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: [].concat(payload.data),
      token: payload.token,
    })
  ),
  [IDENTITY_PRESETS_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/identityPresets.js